import React from 'react';
import BottomBarLogoMenu from './BottomBarLogoMenu';
import footerImg from '../images/companyLogoBottomBar.webp';
import { FollowUsItem } from '../types';

interface BottomBarGridItem {
    title: string;
    items: Array<{ text: string; url: string }>;
}

interface FooterProps {
    followUs: FollowUsItem[];
    bottomBarGridItems: BottomBarGridItem[];
}

function Footer({ followUs, bottomBarGridItems }: FooterProps) {
    return (
        <nav className="bottomBar">
            <div>
                <div className="bottomBarImgContainer">
                    <a href="/">
                        <img src={footerImg}
                             height="234px"
                             width="216px"
                             loading="lazy"
                             decoding="async"
                             alt="Placencia Action Tours company Logo: The Belizean Quetzocoatl" />
                    </a>
                </div>
                <div className="bottomBarLogoText">
                    <div className="bottomBarLogoTextBack">
                        Placencia
                    </div>
                    <div>
                        Action
                    </div>
                    <div className="bottomBarLogoTextBack">
                        Tours
                    </div>
                </div>
            </div>
            <BottomBarLogoMenu followUs={followUs} bottomBarGridItems={bottomBarGridItems} />
        </nav>
    );
}

export default Footer;
